import { pdsTv } from '@purinanbm/pds-ui';
import React from 'react';
import { CMS_THEME } from 'src/common/enums';
import { ContentBlock } from 'src/components/ContentBlock/ContentBlock';
import { CmsButtonLink } from 'src/components/button/CmsButton';
import { fromStorageToContentBlock } from './fromStorageToContentBlock';
import { BUTTON_HIERARCHY, StorageContentBlockProps } from './types';

export const StorageContentBlock = ({ className, ...props }: StorageContentBlockProps) => {
  const contentBlockProps = fromStorageToContentBlock(props.node);
  const primaryButtonVariation = props.node.behaviors?.entity_buttons?.primary_button ?? 'btn';
  const primaryButtonVariationIndex = BUTTON_HIERARCHY.indexOf(primaryButtonVariation);
  const { links } = props.node;

  const bodyTv = pdsTv({
    base: 'pds-text-balance',
    variants: {
      richTextSize: {
        small: 'prose-p:pds-text-body-sm',
        medium: 'prose-p:pds-text-body-md',
        large: 'prose-p:pds-text-body-lg',
      },
    },
    defaultVariants: {
      richTextSize: 'medium',
    },
  });

  const containerTv = pdsTv({
    base: 'pds-flex pds-flex-col',
    variants: {
      textAlign: {
        left: 'pds-items-start',
        center: 'pds-items-center',
        right: 'pds-items-end',
      },
    },
  });

  if (props.richTextSize && contentBlockProps.body) {
    contentBlockProps.body.className = bodyTv({ richTextSize: props.richTextSize });
  }

  if (links) {
    contentBlockProps.children = links.length
      ? links.map((link, index) => (
          <CmsButtonLink
            analytics={!props.actionCallback}
            key={link.url}
            to={link.url}
            onClick={() => props.actionCallback?.(link, index)}
            variant={BUTTON_HIERARCHY[Math.min(primaryButtonVariationIndex + index, 3)] ?? 'btn'}
            cmsTheme={contentBlockProps.theme ?? CMS_THEME.LIGHT}
            {...link?.options?.attributes}
          >
            {link.title}
          </CmsButtonLink>
        ))
      : undefined;
  }
  return (
    <div className={containerTv({ className })}>
      <ContentBlock {...contentBlockProps} />
    </div>
  );
};
